<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1 :title="content !== null ? content : 'Uploading'">{{ content !== null ? content : 'Uploading' }}</h1>
      <img :src="require('@/assets/images/loading.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>
